module.exports = __webpack_public_path__ + "img/artProfile.0811e7cc.png";